import { put } from 'redux-saga/effects';

import * as uiActions from '../actions';

export function* setFeatureFlagSaga(action = {}) {
    try {
        const { payload } = action;
        yield put(uiActions.setFeatureFlag.success(payload));
    } catch (error) {
        yield put(uiActions.setFeatureFlag.error(error));
    }
}
